import React, { createContext, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from '../UserContext';
import { API_URLS } from '../config';
import { templateDefinitions } from './templateDefinitions';

const defaultTemplate = {
    id: 'classic',
    name: 'Classic',
    backgroundColor: '#fff',
    textColor: '#222',
    borderStyle: 'solid',
    borderColor: '#eee',
    borderWidth: 1,
    surveyPosition: 'center',
    surveyMaxWidth: 'none',
    surveyBackground: 'transparent',
    surveyBorder: 'none',
    headerOverlay: false,
    customCSS: '',
    isLoading: true,
};

export const TemplateContext = createContext(defaultTemplate);

export const TemplateProvider = ({ children }) => {
    const [template, setTemplate] = useState(defaultTemplate);
    const { token } = useContext(UserContext);
    const { id } = useParams();

    useEffect(() => {
        if (!token || !id) {
            setTemplate(prev => ({ ...prev, isLoading: false }));
            return;
        }

        setTemplate(prev => ({ ...prev, isLoading: true }));

        fetch(API_URLS.template(id), {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log("Template data fetched:", data);
            if (data && data.template_config) {
                const config = JSON.parse(data.template_config);
                setTemplate({
                    ...defaultTemplate,
                    ...config,
                    isLoading: false,
                });
            } else {
                setTemplate({ ...defaultTemplate, isLoading: false });
            }
        })
        .catch(error => {
            console.error("Error fetching template:", error);
            setTemplate({ ...defaultTemplate, isLoading: false });
        });

    }, [id, token]);

    const updateTemplate = (newTemplate) => {
        setTemplate(prev => ({ ...prev, ...newTemplate }));
    };

    const applyTemplate = (templateId) => {
        const templateDef = templateDefinitions[templateId];
        if (templateDef) {
            setTemplate(prev => ({ ...prev, ...templateDef }));
        }
    };

    const saveTemplate = async (templateConfig) => {
        if (!token || !id) return;

        try {
            const response = await fetch(API_URLS.template(id), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    template_config: JSON.stringify(templateConfig)
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            setTemplate(prev => ({ ...prev, ...templateConfig }));
            return true;
        } catch (error) {
            console.error("Error saving template:", error);
            return false;
        }
    };

    return (
        <TemplateContext.Provider value={{
            ...template,
            updateTemplate,
            applyTemplate,
            saveTemplate
        }}>
            {children}
        </TemplateContext.Provider>
    );
};
